import {cn} from "@/lib/utils";
import Image from "next/image";
import React, {Dispatch, SetStateAction} from "react";

interface Props {
  onClick: Dispatch<SetStateAction<string>>;
  slug: string;
  sector: string;
  trend: string;
  trendsChange: number;
}

export const GTrendsDetailCard: React.FC<Props> = ({
  onClick,
  slug,
  sector,
  trend,
  trendsChange,
}) => {
  return (
    <button
      onClick={() => onClick(sector)}
      className="rounded-lg h-24 w-full hover:cursor-pointer flex flex-col justify-center items-center gap-3 bg-cover drop-shadow-lg shadow-[inset_0_0_0_1000px_rgba(0,0,0,0.65)]"
      style={{
        backgroundImage: `url(/images/sectors/${slug}.jpg)`,
      }}
    >
      <p className="text-center text-white text-sm font-medium">{sector}</p>
      <div className="flex justify-center items-center">
        <div className="relative h-8 w-8 mx-1">
          <Image
            src={trend == "up" ? "/arrow-up.svg" : "/arrow-down.svg"}
            alt="arrow up"
            fill
          />
        </div>
        <span
          className={cn(
            "mx-1 text-xl font-bold",
            trend == "up" ? "text-[#07B0F8]" : "text-[#F84F07]"
          )}
        >
          {trendsChange ? trendsChange.toFixed(1) : "0.0"}%
        </span>
      </div>
    </button>
  );
}
